import type { FormDefinition } from '@/core/templates/types'
import { massnahmeDetailsVergabeForm } from './templates'
import type { MassnahmeCoreWrite } from '@/core/api/resources'

export const ORG_SETTINGS_TABS: readonly string[] = ['organisation', 'coaches', 'massnahmen']

export const MASSNAHME_FORM: FormDefinition = massnahmeDetailsVergabeForm

export const MASSNAHME_DEFAULTS: Pick<
  MassnahmeCoreWrite,
  'nummer' | 'bezeichnung' | 'inhalt' | 'ansprechpartner' | 'durchf_ort' | 'durchf_form'
> = {
  ansprechpartner: '',
  bezeichnung: '',
  durchf_form: '',
  durchf_ort: '',
  inhalt: '',
  nummer: '',
}

export const HAS_MODULES = false as const

export const HAS_ECN_SETTINGS = false
